import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin(async () => {
  const { twMerge } = await import('tailwind-merge')
  return {
    provide: {
      twMerge
    }
  }
})
